import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const ThumbDownIcon = (props: SvgIconProps) => (
    <SvgIcon
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ fontSize: 20 }}
        {...props}
    >
        <path
            d="M18.75 10V5.625C18.7487 4.46507 18.2874 3.35302 17.4672 2.53283C16.647 1.71264 15.5349 1.25129 14.375 1.25H1.25V10H5.2905L7.52637 13.3539L8.05469 17.0517C8.09837 17.349 8.24725 17.6209 8.47429 17.8178C8.70132 18.0148 8.99145 18.1238 9.292 18.125H10.625C11.1221 18.1245 11.5987 17.9267 11.9502 17.5752C12.3017 17.2237 12.4995 16.7471 12.5 16.25V12.5H16.25C16.9128 12.4993 17.5483 12.2356 18.0169 11.7669C18.4856 11.2983 18.7493 10.6628 18.75 10ZM5 8.75H2.5V2.5H5V8.75ZM17.5 10C17.4996 10.3314 17.3678 10.6491 17.1334 10.8834C16.8991 11.1178 16.5814 11.2496 16.25 11.25H11.25V16.25C11.2499 16.4157 11.184 16.5746 11.0668 16.6918C10.9496 16.809 10.7907 16.8749 10.625 16.875H9.292L8.72363 12.8961L6.25 9.18581V2.5H14.375C15.2035 2.50094 15.9978 2.83049 16.5837 3.41633C17.1695 4.00218 17.4991 4.79649 17.5 5.625V10Z"
            fill="#616161"
        />
    </SvgIcon>
);

export const HighlightThumbDownIcon = (props: SvgIconProps) => (
    <SvgIcon
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={{ fontSize: 20 }}
        {...props}
    >
        <path
            d="M1.25 1.25H4.375V10H1.25V1.25ZM14.375 1.25H5.625V10.5017L7.52637 13.3539L8.05469 17.0517C8.09837 17.349 8.24725 17.6209 8.47429 17.8178C8.70132 18.0148 8.99145 18.1238 9.292 18.125H9.375C9.87211 18.1245 10.3487 17.9267 10.7002 17.5752C11.0517 17.2237 11.2495 16.7471 11.25 16.25V12.5H16.25C16.9128 12.4993 17.5483 12.2356 18.0169 11.7669C18.4856 11.2983 18.7493 10.6628 18.75 10V5.625C18.7487 4.46507 18.2874 3.35302 17.4672 2.53283C16.647 1.71264 15.5349 1.25129 14.375 1.25Z"
            fill="#E4741E"
        />
    </SvgIcon>
);
